import { formatInTimeZone } from 'date-fns-tz';

import { formatterCurrencyTruncated } from '@utilities/format';
import type { NoteReminderQueryType } from '../hooks/types';

export const generateEventBasedReminderMessage = (
  sharePrice: number,
  currencyISO: string,
  variation?: 'exceeds' | 'drops below'
) => {
  const formattedSharePrice = formatterCurrencyTruncated(
    sharePrice,
    currencyISO,
    2
  );

  if (typeof variation === 'undefined') {
    return `We'll email you a reminder when the closing price reaches ${formattedSharePrice}`;
  }

  return `We'll email you a reminder when the closing price ${variation} ${formattedSharePrice}`;
};

export const generateDateBasedReminderMessage = (
  date: Date,
  userTimezone?: string
) => {
  // NOTE: compatibility for https://caniuse.com/mdn-javascript_builtins_intl_datetimeformat_resolvedoptions_computed_timezone
  const timezone =
    typeof userTimezone === 'undefined'
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : userTimezone;

  const formattedDate = formatInTimeZone(date, timezone, 'dd MMM yyyy');
  return `We'll email you a reminder on ${formattedDate}`;
};

export const generateReminderMessage = (reminder: NoteReminderQueryType) => {
  if (
    reminder.type === 'date_based' &&
    typeof reminder.deliveryDateUtc === 'string'
  ) {
    const date = new Date(reminder.deliveryDateUtc);
    return generateDateBasedReminderMessage(date, reminder.userTimezone);
  }
  if (
    reminder.type === 'event_based' &&
    typeof reminder.reminderTarget !== 'undefined' &&
    typeof reminder.reminderTarget.targetMetadata?.currencyISO !== 'undefined'
  ) {
    const sharePrice = reminder.reminderTarget.targetValue;
    const currencyISO = reminder.reminderTarget.targetMetadata?.currencyISO;
    return generateEventBasedReminderMessage(sharePrice, currencyISO);
  }
  return reminder.customMessage;
};
